<script setup lang="ts">
import KBtn from '@/components/btns/KBtn.vue';

export interface Props {
  downloadHref?: string;
  isDeleteFetching?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  downloadHref: '',
  isDeleteFetching: false,
});
const emit = defineEmits<{
  deleteClick: [event: Event];
}>();

function handleDeleteClick(event: Event): void {
  emit('deleteClick', event);
}
</script>

<template>
  <menu
    :class="$style.detailedJobAttachmentsActionsMenuList"
    data-testid="detailedJobAttachmentsActionsMenuList"
  >
    <li :class="$style.li">
      <KBtn
        :class="$style.btn"
        variant="text"
        append-icon="mdi-delete-outline"
        :disabled="!props.downloadHref"
        priority="danger"
        :loading="props.isDeleteFetching"
        @click="handleDeleteClick"
      >
        Delete
      </KBtn>
    </li>
    <li :class="$style.li">
      <KBtn
        :class="$style.btn"
        variant="text"
        append-icon="mdi-download-outline"
        :disabled="!props.downloadHref"
        :href="props.downloadHref"
        target="_blank"
        priority="info"
      >
        Download
      </KBtn>
    </li>
  </menu>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.detailedJobAttachmentsActionsMenuList {
  margin: 0;
  padding: 0;
  list-style: none;
}
  .li {
    display: inline-block;
  }
    .btn {
      :global {
        .v-btn__content {
          text-transform: none;
        }
      }
    }
</style>
